<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" (click)="addHoliday(0)"
                [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Holiday':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Holiday Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Holiday Name</th>
                        <th style="width: 20px;">HolidayType</th>
                        <!-- <th style="width: 5px;">Active</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                         <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i (click)="addHoliday(TableData['ESS_HolidayMasterID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td>{{TableData['HolidayName']}}</td>
                        <td style="width: 20px;">{{TableData['HolidayType']}}</td>
                        <!-- <td style="width: 5px;">{{TableData['Active']?'Yes':'No'}}</td> --> 
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">

                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="exportToExcel()">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                    &nbsp;
                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="downloadExcel()">
                        <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Sample':'Loading...'}}
                    </button>
                    &nbsp;
                    <label *ngIf="this.common.PageRight.IsPrint" for="file-upload" class="btn btn-sm btn-primary">
                        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                    </label>
                    <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                        accept=".xls,.xlsx">
                </div>
            </div>
        </div>
    </div>
</div>